// extracted by mini-css-extract-plugin
export default {"border":"Guardian_border__twPJj","color":"Guardian_color__+EArZ"};